export const PIPELINE_INPUT_DELAY = 750;
export const PIPELINE_CACHE_TTL_MS = 120000;
export const PIPELINE_BOARD_DESKTOP_MIN_WIDTH = 668;
export const PIPELINE_BOARD_LAYOUT_QUERY_KEY = 'layout';

export const PIPELINE_DEAL_SEARCH_PAGE_SIZE = 15;

export const DEFAULT_PIPELINE_MENU_ICON = 'fa-solid fa-grip';

export const PIPELINE_MENU_ICON_BY_REFERENCE_ID: Record<string, string> = {
  'realty-homeequity': 'fa-solid fa-money-bills',
  vehicle: 'fa-solid fa-car-rear',
  'realty-financing': 'fa-solid fa-house-circle-check',
  'partner-qualification': 'fa-solid fa-handshake-angle',
};

export const PIPELINE_NAME_MAP: Record<string, string> = {
  'pipeline-cgi': 'crédito com garantia de imóvel',
  'pipeline-cgv': 'crédito com garantia de veículo',
  'pipeline-fi': 'financiamento imobiliário',
  'pipeline-qualificacao-de-parceiros': 'qualificação de parceiros',
} as const;

export const resolvePipelineRouteDisplayName = (
  pipelineName: string | string[] | undefined,
): string => {
  if (typeof pipelineName !== 'string' || !pipelineName) {
    return '';
  }
  return PIPELINE_NAME_MAP[pipelineName] ?? pipelineName;
};
